import React from 'react';

const attrsToStyle = attrs => {
  let style = {};
  if (attrs && attrs.textAlign) {
    style.textAlign = attrs.textAlign;
  }
  if (Object.keys(style).length == 0) {
    return undefined;
  }
  return style;
};

const BlockQuote = _ref => {
  let {
    children,
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("blockquote", {
    style: attrsToStyle(attrs)
  }, children);
};

const BulletList = _ref => {
  let {
    children,
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("ul", {
    style: attrsToStyle(attrs)
  }, children);
};

const CodeBlock = _ref => {
  let {
    children,
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("pre", {
    style: attrsToStyle(attrs)
  }, children);
};

const Doc = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

const DocumentLink = _ref => {
  let {
    children,
    node
  } = _ref;
  console.warn("documentLink should be implemented with an overwrite in the richtext");
  return /*#__PURE__*/React.createElement(React.Fragment, null, node?.attrs?.documentId ?? "", children);
};

const HardBreak = () => /*#__PURE__*/React.createElement("br", null);

const Heading = _ref => {
  let {
    node,
    children
  } = _ref;
  const attrs = node.attrs;
  const level = node.attrs.level;
  switch (level) {
    case 1:
      return /*#__PURE__*/React.createElement("h1", {
        style: attrsToStyle(attrs)
      }, children);
    case 2:
      return /*#__PURE__*/React.createElement("h2", {
        style: attrsToStyle(attrs)
      }, children);
    case 3:
      return /*#__PURE__*/React.createElement("h3", {
        style: attrsToStyle(attrs)
      }, children);
    case 4:
      return /*#__PURE__*/React.createElement("h4", {
        style: attrsToStyle(attrs)
      }, children);
    case 5:
      return /*#__PURE__*/React.createElement("h5", {
        style: attrsToStyle(attrs)
      }, children);
    case 6:
      return /*#__PURE__*/React.createElement("h6", {
        style: attrsToStyle(attrs)
      }, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

const IFrame = _ref => {
  let {
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("iframe", {
    style: attrsToStyle(attrs),
    src: attrs.src,
    allow: attrs.allow,
    title: attrs.title,
    frameBorder: attrs.frameborder,
    height: attrs.height,
    width: attrs.width,
    allowFullScreen: attrs.allowfullscreen
  });
};

const ListItem = _ref => {
  let {
    children,
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("li", {
    style: attrsToStyle(attrs)
  }, children);
};

const OrderedList = _ref => {
  let {
    children,
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("ol", {
    style: attrsToStyle(attrs)
  }, children);
};

const Paragraph = _ref => {
  let {
    children,
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("p", {
    style: attrsToStyle(attrs)
  }, children);
};

const Table = _ref => {
  let {
    children,
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", {
    style: attrsToStyle(attrs)
  }, children));
};

const TableCel = _ref => {
  let {
    children,
    node: {
      attrs
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("td", {
    colSpan: attrs?.colspan ? attrs?.colspan : undefined,
    rowSpan: attrs?.rowspan ? attrs?.rowspan : undefined,
    style: attrsToStyle(attrs)
  }, children);
};

const TableHeader = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("th", null, children);
};

const TableRow = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("tr", null, children);
};

const Mark = _ref => {
  let {
    mark,
    attrs,
    children
  } = _ref;
  switch (mark) {
    case "bold":
      return /*#__PURE__*/React.createElement("strong", null, children);
    case "code":
      return /*#__PURE__*/React.createElement("code", null, children);
    case "italic":
      return /*#__PURE__*/React.createElement("em", null, children);
    case "strike":
      return /*#__PURE__*/React.createElement("s", null, children);
    case "link":
      return /*#__PURE__*/React.createElement("a", {
        href: attrs.href,
        target: attrs.target
      }, children);
    default:
      console.warn(`unknown mark type: ${mark}`);
      if (children) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, children);
      } else {
        return null;
      }
  }
};
const Text = _ref2 => {
  let {
    node
  } = _ref2;
  return node.marks ? node.marks.reduce((memo, mark) => {
    return /*#__PURE__*/React.createElement(Mark, {
      mark: mark.type,
      attrs: mark.attrs
    }, memo);
  }, /*#__PURE__*/React.createElement(React.Fragment, null, node.text)) : /*#__PURE__*/React.createElement(React.Fragment, null, node.text);
};

const DEFAULT_BLOCK_MAP = {
  doc: Doc,
  hardBreak: HardBreak,
  paragraph: Paragraph,
  codeBlock: CodeBlock,
  blockquote: BlockQuote,
  bulletList: BulletList,
  orderedList: OrderedList,
  listItem: ListItem,
  heading: Heading,
  iframe: IFrame,
  table: Table,
  tableRow: TableRow,
  tableHeader: TableHeader,
  tableCell: TableCel,
  text: Text,
  documentLink: DocumentLink
};
const documentRenderer = blockMap => {
  const BLOCKS = {
    ...DEFAULT_BLOCK_MAP,
    ...blockMap
  };
  const renderNode = (currNode, currNodeIndex, parentPath) => {
    const Element = BLOCKS[currNode.type];
    if (!Element) {
      console.log("renderNode -> missing node type:", currNode.type);
      return null;
    }
    const path = (parentPath ? parentPath + "-" : "") + (typeof currNodeIndex === "number" ? currNodeIndex : "");
    return /*#__PURE__*/React.createElement(Element, {
      key: `node-${currNode.type}-${path}`,
      node: currNode,
      path: path
    }, currNode.content?.map((node, index) => renderNode(node, index, path)));
  };
  return renderNode;
};
var renderer = documentRenderer(DEFAULT_BLOCK_MAP);

const RichTextRenderer = _ref => {
  let {
    node,
    overwrites
  } = _ref;
  if (!node) {
    return null;
  }
  const renderer = documentRenderer(overwrites || {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderer(node));
};

export { DEFAULT_BLOCK_MAP, RichTextRenderer, renderer as default, documentRenderer };
//# sourceMappingURL=index.js.map
